// src/client/wrappers/routes.js

'use strict';

let currentRoutes;

/**
 * Сохранить пути к заданию и проверке в моделе-синглтоне
 * При дальнейшем вызове getRoutes во всем приложении будут использованы заданные пути
 *
 * @param {object} routes
 *
 * @example
 * setRoutes({
 *   task: '/courses/:courseId/run/:taskId',
 *   check: '/courses/:courseId/server-check/:taskId'
 * })
 */
exports.setRoutes = (routes) => {
  currentRoutes = routes;
};

exports.getRoutes = function (baseRoute, routesConfig) {
  const getCurrentRoutes = () => routesConfig || {
    ...getRoutesFromConfig(),
    ...currentRoutes
  };

  var getRoutesFromConfig = function () {
    var config = require('config');
    var routes;
    try {
      routes = config.express.serve.routes;
    } catch (err) {
      routes = {};
    }

    return routes;
  };

  var getRouteParams = function (route) {
    var params = {};
    var routes = getCurrentRoutes();
    var taskRoute = routes.task || '';

    var routeParts = route.split('/');
    var taskParts = taskRoute.split('/');

    for (let i = 0; i < Math.min(routeParts.length, taskParts.length); i++) {
      if (taskParts[i].startsWith(':')) {
        params[taskParts[i].substr(1)] = routeParts[i];
      }
    }

    return params;
  };

  var setRouteParams = function (route, params) {
    var routeParts = route.split('/');

    for (var i = 0; i < routeParts.length; i++) {
      if (routeParts[i].startsWith(':')) {
        var name = routeParts[i].substr(1);

        if (params[name]) {
          routeParts[i] = params[name];
        }
      }
    }

    return routeParts.join('/');
  };

  var getSourceRoute = function () {
    return (baseRoute || window.location.pathname);
  };

  var getServerCheckRoute = function () {
    var sourceRoute = getSourceRoute();
    var routes = getCurrentRoutes();

    if (typeof routes.check === 'string') {
      const params = getRouteParams(sourceRoute);
      return setRouteParams(routes.check, params);
    }

    return sourceRoute;
  };

  var getParams = function () {
    return getRouteParams(getSourceRoute());
  };

  var getAssetsRoute = function () {
    return (
      document.body.dataset ||
      {}
    ).base;
  };

  return {
    getSourceRoute,
    getServerCheckRoute,
    getAssetsRoute,
    getParams
  };
};
